import React, { useState, useEffect } from "react";
import {
  Box,
  Heading,
  Button,
  Text,
  Input,
  InputGroup,
  InputLeftElement,
  HStack
} from "@chakra-ui/react";
import DataTable from "./AppDataTable";
import { useNavigate, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faSearch, faTable } from "@fortawesome/free-solid-svg-icons";
import { tableCustomStyles } from "../themes/TableStyles";

const ResponseList = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [questionnaire, setQuestionnaire] = useState(null);
  const [responses, setResponses] = useState([]);
  const [filteredResponses, setFilteredResponses] = useState([]);
  const [filterText, setFilterText] = useState("");

  useEffect(() => {
    // Load questionnaire and responses from local storage
    try {
      const questionnaires = JSON.parse(
        localStorage.getItem("questionnaires") || "[]"
      );
      const q = questionnaires.find((q) => q.id === id);
      if (q) {
        setQuestionnaire(q);
        const allResponses = JSON.parse(
          localStorage.getItem("responses") || "[]"
        );
        const filtered = allResponses.filter((r) => r.questionnaireId === id);
        setResponses(filtered);
        setFilteredResponses(filtered);
      } else {
        alert("ไม่พบแบบสอบถาม");
        navigate("/questionnaire-list");
      }
    } catch (error) {
      console.error("Error loading data:", error);
      navigate("/questionnaire-list");
    }
  }, [id, navigate]);

  useEffect(() => {
    // Filter responses based on submission date or field values
    const filtered = responses.filter((response) => {
      const dateStr = new Date(response.submittedAt).toLocaleString();
      const responseValues = Object.values(response.responses)
        .flat()
        .join(" ")
        .toLowerCase();
      return (
        dateStr.toLowerCase().includes(filterText.toLowerCase()) ||
        responseValues.includes(filterText.toLowerCase())
      );
    });
    setFilteredResponses(filtered);
  }, [filterText, responses]);

  if (!questionnaire) return null;
  const columns = [
    {
      name: "วันที่ส่ง",
      selector: (row) => new Date(row.submittedAt).toLocaleString(),
      sortable: true,
      wrap: true,
    },
    ...questionnaire.fields.map((field) => ({
      name: field.label,
      selector: (row) =>
        Array.isArray(row.responses[field.name])
          ? row.responses[field.name].join(", ")
          : row.responses[field.name] || "-",
      sortable: true,
      wrap: true,
    })),
  ];
  return (
    <Box p={35} m={25} borderWidth={1} borderRadius="lg" boxShadow="lg">
      <Box
        mb={5}
        borderRadius="full"
        w="100%"
        bgColor="iPink.500"
        color="white"
        p={2}
      >
        <HStack spacing={5} ml={5}>
          <FontAwesomeIcon icon={faTable} color="white" size="xl" />
          <Heading size="lg" fontWeight="normal">
            ผลลัพธ์: {questionnaire.title}
          </Heading>
        </HStack>
      </Box>
      <Box m={10}>
        <Button
          leftIcon={<FontAwesomeIcon icon={faArrowLeft} />}
          colorScheme="gray"
          mb={6}
          onClick={() => navigate("/questionnaire-list")}
        >
          กลับไปยังรายการแบบสอบถาม
        </Button>
        <Text mb={6}>ทั้งหมด {filteredResponses.length} คำตอบ</Text>
        <InputGroup mb={6}>
          <InputLeftElement pointerEvents="none">
            <FontAwesomeIcon icon={faSearch} color="gray.300" />
          </InputLeftElement>
          <Input
            placeholder="ค้นหตามวันที่หรือคำตอบ"
            value={filterText}
            onChange={(e) => setFilterText(e.target.value)}
            colorScheme="iBlue"
          />
        </InputGroup>
        <DataTable
          columns={columns}
          data={filteredResponses}
          highlightOnHover
          striped
          responsive
          customStyles={tableCustomStyles}
          noDataComponent={
            <Text textAlign="center" p={5}>
              ยังไม่มีคำตอบสำหรับแบบสอบถามนี้
            </Text>
          }
        />
      </Box>
    </Box>
  );
};

export default ResponseList;
